import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import FeaturedFeed from "./components/FeaturedFeed";
import Categories from "./components/Categories";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <HotRank />
      <FeaturedFeed />
      <Categories />
      <Faq />
      <About />
      <Footer />
      <BackToTop />
    </main>
  );
}